import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .table {
    margin-bottom: 8px;

    .highlight {
      background: linear-gradient(
        90deg,
        rgba(120, 92, 255, 0.17) 1.63%,
        rgba(123, 96, 254, 0.165519) 50.81%,
        rgba(136, 113, 249, 0.142245) 100%
      );
    }

    .ant-table-cell {
      padding: 6px 16px;
    }
  }
`

export const StyledTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const StyledLONBalance = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  margin: 18px 0 16px;
  padding: 12px 15px;
  width: 100%;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 0.5px solid #d0c8fa;
  border-radius: 48px;

  p {
    margin: 0;
  }

  .main-label {
    color: #000000;
    font-weight: 400;
    font-size: 13px;
    line-height: 140%;
  }

  .main-desc {
    color: ${({ theme }) => theme.colors.textTertiary};
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;

    .through {
      text-decoration: line-through;
    }

    .highlight {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .label-wrapper {
    display: flex;
    align-items: center;

    .fee-intro-tooltip {
      height: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .label {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: ${({ theme }) => theme.colors.textTertiary};
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`

export const StyledTableHeader = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.textTertiary};
`

export const StyledNote = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.textTitle};

  a {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const StyledButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 48px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 12px 0;
  width: 100%;
  margin-top: 30px;
  cursor: pointer;
`
